// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.menu-btn {
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border: 1px solid #707070;
    border-radius: 10px;
    min-height: 90px;
    cursor: pointer;
    padding: 10px;
}

@media (min-width: 1000px) {
    .menu-btn {
        min-height: 90px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/menuButton/MenuButton.css"],"names":[],"mappings":";AACA;IACI,+CAA+C;IAC/C,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,aAAa;AACjB;;AAEA;IACI;QACI,gBAAgB;IACpB;AACJ","sourcesContent":["\n.menu-btn {\n    background: #FFFFFF 0% 0% no-repeat padding-box;\n    border: 1px solid #707070;\n    border-radius: 10px;\n    min-height: 90px;\n    cursor: pointer;\n    padding: 10px;\n}\n\n@media (min-width: 1000px) {\n    .menu-btn {\n        min-height: 90px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
